import { render, staticRenderFns } from "./CompanyIndex.vue?vue&type=template&id=2415af38&scoped=true&"
import script from "../../services/company/company-index.js?vue&type=script&lang=js&"
export * from "../../services/company/company-index.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/index.css?vue&type=style&index=0&id=2415af38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2415af38",
  null
  
)

export default component.exports